import { z } from 'zod';
import { recurringTypeValues } from '@/entities/settlementstatisticsconverter/lib/recurring-type';
import { revenueSourceTypeValues } from '@/entities/settlementstatisticsconverter/lib/revenue-source-type';

/**
 * 歳入コード振り結果 訂正フォームのバリデーションスキーマ
 */
export const revenueEditSchema = z.object({
  /** 決算統計目的（CascaderFieldのコードパス） */
  settlement_purpose_code_path: z.array(z.string()).min(1),
  /** 臨時経常区分 */
  recurring_type_value: z.enum(recurringTypeValues),
  /** 財源区分 */
  revenue_source_type_value: z.enum(revenueSourceTypeValues),
});

export type RevenueEditFormValues = z.infer<typeof revenueEditSchema>;
